import PropTypes from 'prop-types'

function SettingsToggle({
  label,
  description,
  checked,
  onChange,
  disabled = false,
  className = '',
  layout = 'horizontal', // 'horizontal' or 'vertical'
}) {
  if (layout === 'vertical') {
    return (
      <div className={`flex flex-col space-y-3 ${className}`}>
        <label className="text-sm font-medium text-neutral-900 dark:text-white text-left">
          {label}
        </label>
        <button
          type="button"
          role="switch"
          aria-checked={checked}
          disabled={disabled}
          onClick={() => !disabled && onChange(!checked)}
          className={`
            self-start relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2
            ${checked ? 'bg-primary-600 dark:bg-primary-500' : 'bg-neutral-200 dark:bg-neutral-700'}
            ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
          `}
        >
          <span
            className={`
              inline-block h-4 w-4 transform rounded-full bg-white transition-transform duration-200 ease-in-out
              ${checked ? 'translate-x-6' : 'translate-x-1'}
            `}
          />
        </button>
        {description && (
          <p className="text-sm text-neutral-600 dark:text-neutral-400 text-left">{description}</p>
        )}
      </div>
    )
  }

  // Horizontal layout with justify-between (default)
  return (
    <div className={`flex items-center justify-between w-full ${className}`}>
      <div className="flex-1 min-w-0">
        <label className="text-sm font-medium text-neutral-900 dark:text-white block text-left">
          {label}
        </label>
        {description && (
          <p className="text-sm text-neutral-600 dark:text-neutral-400 mt-1 text-left">
            {description}
          </p>
        )}
      </div>
      <div className="flex-shrink-0 ml-4">
        <button
          type="button"
          role="switch"
          aria-checked={checked}
          disabled={disabled}
          onClick={() => !disabled && onChange(!checked)}
          className={`
            relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2
            ${checked ? 'bg-primary-600 dark:bg-primary-500' : 'bg-neutral-200 dark:bg-neutral-700'}
            ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
          `}
        >
          <span
            className={`
              inline-block h-4 w-4 transform rounded-full bg-white transition-transform duration-200 ease-in-out
              ${checked ? 'translate-x-6' : 'translate-x-1'}
            `}
          />
        </button>
      </div>
    </div>
  )
}

SettingsToggle.propTypes = {
  label: PropTypes.string.isRequired,
  description: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  layout: PropTypes.oneOf(['horizontal', 'vertical']),
}

export default SettingsToggle
